import { useMemo, useState } from 'react';
import { isValid } from 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

export { default as MyTimePicker } from './WheelTimePicker';

export function DatePicker({ value, onChange, onValidityChange, onError, inputProps, ...others }) {
  const externalDate = useMemo(() => new Date(value + 'T00:00:00'), [value]);
  // Keep the keyboard picker's null/invalid Date local until entry is complete.
  const [draft, setDraft] = useState(null);
  const date = draft?.source === value ? draft.date : externalDate;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy-MM-dd"
        margin="normal"
        value={date}
        inputProps={{
          inputMode: 'numeric',
          onFocus: (event) => event.target.select(),
          ...inputProps
        }}
        {...others}
        onChange={(nextDate, text) => {
          if (others.disabled || others.readOnly) return;
          setDraft({ source: value, date: nextDate });
          if (isValid(nextDate)) onChange?.(nextDate, text);
        }}
        onError={(error, nextDate) => {
          onValidityChange?.(nextDate !== null && !error);
          onError?.(error, nextDate);
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
